import { bindable, BindingMode, watch } from 'aurelia';
import debounce from 'debounce';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

export class PriceRangeFilter {

    @bindable({ mode: BindingMode.twoWay }) selected = { min: 0, max: 3000 };
    @bindable class = "";

    default = { min: 0, max: 3000 };
    isMobile = false;
    mediaQuery = null;
    
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;

    constructor() {}

    binding() {
        this.default = this.selected;
    }

    attached() {
        this.mediaQuery = window.matchMedia('(min-width: 900px)');
        this.isMobile = !this.mediaQuery.matches;
        this.mediaQuery.addEventListener('change', this.onMatchMediaChange);
        this.initSlider();
    }

    detached() {
        this.mediaQuery.removeEventListener('change', this.onMatchMediaChange);
    }
    
    onMatchMediaChange = (e) => {
        this.isMobile = !e.matches;
    };

    @watch('isMobile')
    isMobileChanged() {
        this.initSlider();
    }

    initSlider() {
        let sliderEl = this.isMobile ? document.querySelector('#mobile-price-range-nouislider') : document.querySelector('#price-range-nouislider');
        if (sliderEl.noUiSlider) return;
        noUiSlider.create(sliderEl, {
            start: [this.selected.min, this.selected.max],
            connect: [false, true, false],
            step: 1,
            margin: Math.ceil((this.selected.max - this.selected.min) * this.aurelia_options.pricerangeslider_margin_multiplier),
            range: {
                'min': this.selected.min,
                'max': this.selected.max
            },
            format: wNumb({
                decimals: 0,
                thousand: '',
                postfix: '',
            })
        });
        sliderEl.noUiSlider.on('update', debounce(() => {
            let values = sliderEl.noUiSlider.get();
            this.selected = { min: Number.parseInt(values[0]), max: Number.parseInt(values[1]) }
        }, 400));
    }

    resetFilter() {
        this.selected = this.default;
    }

    openCloseFilter() {
        document.querySelector('#price-range-dropdown')?.dispatchEvent(new CustomEvent('e-toggle'));
    }
}
